module.exports = __webpack_public_path__ + "images/emoji/heavy_plus_sign.aaad5c2d0042078bad81.png";